module.exports = __webpack_public_path__ + "assets/img/media-music-layer-46-32e5eb81.png";